export const LIGHT_ELSA = 'LIGHT_ELSA'; // button z elsą
export const LIGHT_INFORMATION_MENU = 'LIGHT_INFORMATION_MENU'; // button z informacjami
export const LIGHT_REPORTS_MENU = 'LIGHT_REPORTS_MENU'; // button z raportami
export const LIGHT_MANAGEMENT_MENU = 'LIGHT_MANAGEMENT_MENU'; // button z zarządzaniem
export const LIGHT_ESO_EMPLOYEES = 'LIGHT_ESO_EMPLOYEES'; // button jednostki pracownika
export const LIGHT_COOPERATING_ESOS = 'LIGHT_COOPERATING_ESOS'; // button oddzialy wspoplracujace
export const LIGHT_NC_PANEL = 'LIGHT_NC_PANEL'; // button dostepu do części Nemo Cyfrowe
export const LIGHT_NC_CHANGE_ASSIGNMENT_BTN = 'LIGHT_NC_CHANGE_ASSIGNMENT_BTN'; // button przepisywania zadania;
